import React from 'react';
import { CtaButton } from './CtaButton';
import { Check } from 'lucide-react';
export function FinalCTA() {
  const includes = ['Ebook principal — 7 módulos y 30+ recetas', 'Bonus 1: Lista de compras inteligente', 'Bonus 2: Postres en air fryer (10 recetas)', 'Bonus 3: Comida chatarra saludable', 'Garantía de 5 días sin preguntas'];
  return <section className="py-24 px-4 bg-brand-purple" data-id="element-47">
      <div className="max-w-4xl mx-auto text-center" data-id="element-48">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-49">
          Tu air fryer lleva meses esperando.
        </h2>
        <p className="text-xl md:text-2xl text-white/90 font-medium mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-50">
          Esta noche podés cocinar algo rico en 20 minutos. Sin experiencia. Sin
          ingredientes raros. Sin complicaciones.
        </p>

        <div className="bg-brand-purpleDark rounded-3xl p-8 md:p-12 mb-10 border border-white/10" data-id="element-51">
          <h3 className="text-white font-bold text-2xl mb-6" data-id="element-52">
            Todo lo que recibís hoy
          </h3>

          <div className="space-y-3 mb-8 text-left max-w-2xl mx-auto" data-id="element-53">
            {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-54">
                <Check className="w-6 h-6 text-brand-yellow flex-shrink-0" strokeWidth={3} data-id="element-55" />
                <span className="text-white font-medium text-lg" data-id="element-56">{item}</span>
              </div>)}
          </div>

          <div className="text-center mb-8 py-6 border-t border-b border-white/10" data-id="element-57">
            <p className="text-gray-400 line-through text-xl mb-1" data-id="element-58">
              $30.000 valor real
            </p>
            <p className="text-brand-yellow text-6xl md:text-7xl font-serif font-bold" data-id="element-59">
              $6.999 <span className="text-2xl" data-id="element-60">ARS</span>
            </p>
            <p className="text-white/70 mt-2" data-id="element-61">hoy</p>
          </div>

          <CtaButton text="→ Quiero mis recetas ahora" size="xl" className="w-full mb-6" data-id="element-62" />

          <p className="text-sm text-white/60 font-medium" data-id="element-63">
            Acceso inmediato · Pago seguro · Descarga en PDF
          </p>
        </div>
      </div>
    </section>;
}